export function insertRowFromTemplate(listEl, templateEl, index) {
  const html = templateEl.innerHTML.replace(/NEW_INDEX/g, index);
  listEl.insertAdjacentHTML("beforeend", html);
}

export function removeRow(row, destroySelector) {
  const destroyInput = row.querySelector(destroySelector);
  const idInput = row.querySelector("input[name*='[id]']");
  if (destroyInput && idInput && idInput.value) {
    destroyInput.value = "true";
    row.classList.add("hidden");
  } else {
    row.remove();
  }
}

export function updateSortKeys(listEl, rowSelector, sortKeySelector) {
  listEl.querySelectorAll(`${rowSelector}:not(.hidden)`).forEach((row, index) => {
    const input = row.querySelector(sortKeySelector);
    if (input) input.value = index;
  });
}
